import React from 'react';
import { Grid } from 'e100-react-components';

import { useStyles } from './styles';

export const FixedFooterContainer = ({
  children,
  footer
}: FixedFooterContainerProps) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      classes={{
        root: classes.container
      }}
      spacing={0}
    >
      <Grid
        item
        classes={{
          root: classes.content
        }}
      >
        {children}
      </Grid>
      <Grid item>
        {footer}
      </Grid>
    </Grid>
  );
};

interface FixedFooterContainerProps {
  children: any;
  footer?: any;
}
